module.exports = __webpack_public_path__ + "asset/image-calendar-screenshot-b4c13ca0771ee427.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/calendar-screenshot.png
// module id = X2Q6
// module chunks = 1